import React from "react"
import { DesktopOnly } from "../DesktopOnly"
import { MobileOnly } from "../MobileOnly"
import { DatePickerDesktop } from "./DatePickerDesktop"
import { DatePickerMobile } from "./DatePickerMobile"

interface DatePickerProps {
  isVisible: boolean
  onClose: () => void
  selectedDate: string
  onDateSelect: (date: string) => void
  explicitSelectRequired?: boolean
  minDate?: string
  maxDate?: string
  disabledDates?: string[]
  showTaskIndicators?: boolean
}

export const DatePicker: React.FC<DatePickerProps> = (props) => {
  return (
    <>
      <MobileOnly>
        <DatePickerMobile {...props} />
      </MobileOnly>
      <DesktopOnly>
        <DatePickerDesktop {...props} />
      </DesktopOnly>
    </>
  )
}
